import { createContext, useContext } from "react";

export type Publications = {
  id: string;
  title: string;
  filename: string;
  imageObjectUrl: string;
};

export const PublicationsContext = createContext<Publications[] | undefined>(
  undefined,
);

export const usePublicationsContext = () => useContext(PublicationsContext);
